<template>
  <li style="cursor: pointer" class="list-group-item">
    <div
      @click="handleClickActivity"
      v-if="activity.type === 'Stage' && this.$route.name === 'manager_candidate_id'"
      class="activity-container"
    >
      <popper
        :append-to-body="true"
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '10,20px' } },
        }"
      >
        <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>
        <div slot="reference">
          <img
            v-if="
              activity.creator_photo !== null &&
                activity.creator_photo !== 'null' &&
                activity.creator_photo !== 'default.png'
            "
            :src="`https://jobshark.eu/storage/employers/avatars/${activity.creator_photo}`"
            alt="activity thumbnail"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="activity thumbnail" />
        </div>
      </popper>
      <div class="activity-content">
        <div class="activity-header">
          <span class="title">
            <router-link
              :title="activity.job"
              :to="{
                name: 'manager_job_uuid',
                params: { manager_job_uuid: activity.job_id, job_name: activity.job },
              }"
            >
              {{ activity.job }}
              {{
                activity['job-address'] && activity['job-address'].city_name
                  ? `, ${activity['job-address'].city_name}`
                  : ''
              }}
            </router-link></span
          >
          <span class="date">
            {{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}</span
          >
        </div>
        <div class="activity-text">
          <p>
            <span class="bold"
              >Stage change: <span>{{ getStageMixin(activity.stage).title }}</span></span
            >
            {{ activity.comments ? `- ${activity.comments}` : '' }}
          </p>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="activity-container" v-if="activity.type === 'General'">
      <popper
        :append-to-body="true"
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '10,20px' } },
        }"
      >
        <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>
        <div slot="reference">
          <img
            v-if="
              activity.creator_photo !== null &&
                activity.creator_photo !== 'null' &&
                activity.creator_photo !== 'default.png'
            "
            :src="`https://jobshark.eu/storage/employers/avatars/${activity.creator_photo}`"
            alt="activity thumbnail"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="activity thumbnail" />
        </div>
      </popper>

      <div class="activity-content">
        <div class="activity-header">
          <span class="title" v-if="!activity.candidate_name">
            <router-link
              :to="{
                name: 'manager_job_uuid',
                params: { manager_job_uuid: activity.job_id, job_name: activity.job },
              }"
              >{{ activity.job }}
              {{
                activity['job-address'] && activity['job-address'].city_name
                  ? `, ${activity['job-address'].city_name}`
                  : ''
              }}</router-link
            >
          </span>

          <span class="title" v-if="activity.candidate_name"
            ><router-link
              :to="{
                name: 'manager_candidate_id',
                params: { manager_candidate_id: activity.candidate_id },
              }"
              >{{ activity.candidate_name }}</router-link
            ></span
          >
          <span class="date">
            {{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}</span
          >
        </div>
        <div class="activity-text">
          <p>
            {{ activity.comments }}
          </p>
        </div>
      </div>
    </div>
    <!--  -->

    <div
      @click="handleClickActivity"
      v-if="activity.type === 'Pipeline' && this.$route.name === 'manager_candidate_id'"
      class="activity-container"
    >
      <popper
        :append-to-body="true"
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '10,20px' } },
        }"
      >
        <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>
        <div slot="reference">
          <img
            v-if="
              activity.creator_photo !== null &&
                activity.creator_photo !== 'null' &&
                activity.creator_photo !== 'default.png'
            "
            :src="`https://jobshark.eu/storage/employers/avatars/${activity.creator_photo}`"
            alt="activity thumbnail"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="activity thumbnail" />
        </div>
      </popper>
      <div class="activity-content">
        <div class="activity-header">
          <span class="title">
            <router-link
              :to="{
                name: 'manager_job_uuid',
                params: { manager_job_uuid: activity.job_id, job_name: activity.job },
              }"
            >
              {{ activity.job }}
              {{
                activity['job-address'] && activity['job-address'].city_name
                  ? `, ${activity['job-address'].city_name}`
                  : ''
              }}
            </router-link></span
          >
          <span class="date">
            {{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}</span
          >
        </div>
        <div class="activity-text">
          <p>
            <span class="bold"
              >Added to pipeline: <span>{{ getStageMixin(activity.stage).title }}</span></span
            >
            {{ activity.comments ? `- ${activity.comments}` : '' }}
          </p>
        </div>
      </div>
    </div>
    <!-- Manager Job Activity -->
    <div
      @click="handleClickActivity"
      v-if="activity.type === 'Stage' && this.$route.name === 'manager_job_uuid'"
      class="activity-container"
    >
      <popper
        :append-to-body="true"
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '10,20px' } },
        }"
      >
        <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>
        <div slot="reference">
          <img
            v-if="
              activity.creator_photo !== null &&
                activity.creator_photo !== 'null' &&
                activity.creator_photo !== 'default.png'
            "
            :src="`https://jobshark.eu/storage/employers/avatars/${activity.creator_photo}`"
            alt="activity thumbnail"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="activity thumbnail" />
        </div>
      </popper>
      <div class="activity-content">
        <div class="activity-header">
          <span class="title">
            <router-link
              :to="{
                name: 'manager_candidate_id',
                params: { manager_candidate_id: activity.candidate_id },
              }"
            >
              {{ activity.candidate_name }}
            </router-link></span
          >
          <span class="date">
            {{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}</span
          >
        </div>
        <div class="activity-text">
          <p>
            <span class="bold"
              >Stage change: <span>{{ getStageMixin(activity.stage).title }}</span></span
            >
            {{ activity.comments ? `- ${activity.comments}` : '' }}
          </p>
        </div>
      </div>
    </div>
    <div
      @click="handleClickActivity"
      v-if="activity.type === 'Pipeline' && this.$route.name === 'manager_job_uuid'"
      class="activity-container"
    >
      <popper
        :append-to-body="true"
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '10,20px' } },
        }"
      >
        <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>
        <div slot="reference">
          <img
            v-if="
              activity.creator_photo !== null &&
                activity.creator_photo !== 'null' &&
                activity.creator_photo !== 'default.png'
            "
            :src="`https://jobshark.eu/storage/employers/avatars/${activity.creator_photo}`"
            alt="activity thumbnail"
          />
          <img v-else src="https://jobshark.eu/img/comstream.svg" alt="activity thumbnail" />
        </div>
      </popper>
      <div class="activity-content">
        <div class="activity-header">
          <span class="title">
            <router-link
              :to="{
                name: 'manager_candidate_id',
                params: { manager_candidate_id: activity.candidate_id },
              }"
            >
              {{ activity.candidate_name }}
            </router-link></span
          >
          <span class="date">
            {{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}</span
          >
        </div>
        <div class="activity-text">
          <p>
            <span class="bold"
              >Added to pipeline: <span>{{ getStageMixin(activity.stage).title }}</span></span
            >
            {{ activity.comments ? `- ${activity.comments}` : '' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <CustomMainModal @close="onCloseActivityModal" v-show="showModal">
      <template v-slot:header>
        <h5>Activity</h5>
      </template>
      <div class="modal-body">
        <ul class="list-unstyled modal-activity">
          <li v-if="activity.hasOwnProperty('candidate_name')">
            <span class="title">Candidate:</span>
            {{ activity.candidate_name }}
          </li>

          <li class="d-flex">
            <span class="title">Job:</span>

            <span v-show="activity.job"> {{ activity.job }}, {{ getCityName() }} </span>
          </li>
          <li class="d-flex">
            <span class="title">Activity:</span>

            <span v-if="activity.type === 'General'">{{ activity.type }}</span>

            <span v-if="activity.type === 'Stage'">
              Stage change:
              <span class="modal-text-color">{{ getStageMixin(activity.stage).title }}</span>
            </span>

            <span v-if="activity.type === 'Qualification'">
              Qualification change:
              <span class="modal-text-color">
                {{ getQualificationMixin(activity.qualification).title }}
              </span>
            </span>

            <span v-if="activity.type === 'Account_created'">
              Added by {{ activity.creator_name }}
            </span>

            <span v-if="activity.type === 'Pipeline'">
              <!-- 
                  public const ACTIVITY_PIPELINE_APPLIED = 1;
                  public const ACTIVITY_PIPELINE_ADDED = 2;
                  public const ACTIVITY_PIPELINE_REMOVED = 3;
               -->

              <span v-if="activity.activity_pipeline == 1">
                Applied by {{ activity.creator_name }}
              </span>

              <span v-if="activity.activity_pipeline == 2">
                Added to pipeline by {{ activity.creator_name }}
              </span>

              <span v-if="activity.activity_pipeline == 3">
                Removed from pipeline by {{ activity.creator_name }}
              </span>
            </span>
          </li>

          <li>
            <span class="title"></span>
            <textarea
              v-model="activityComment"
              class="form-control"
              rows="2"
              placeholder="Comment"
              :disabled="activity.change_by_js"
            ></textarea>
          </li>

          <li>
            <span class="title">Date:</span
            >{{
              activity.created_at
                | formatDate({
                  format: getManagerUserProfile.format_date,
                  timezone: getManagerUserProfile.timezone,
                  hasHourAndMinutes: false,
                })
            }}
          </li>
        </ul>

        <div class="modal-footer d-flex justify-content-center">
          <button @click="onUpdateActivity" type="button" class="btn btn-primary">
            Save and close
          </button>
          <button
            type="button"
            class="btn btn-secondary mr-3"
            data-dismiss="modal"
            @click="onCloseActivityModal"
          >
            Cancel
          </button>
          <i
            v-if="activity.type === 'General'"
            style="cursor: pointer; font-size: 20px"
            data-bs-toggle="modal"
            :data-bs-target="`#deleteActivityModal-${activity.activity_id}`"
            class="fas fa-trash-alt"
            ref="closeShowActivityModalBtn"
          ></i>
        </div>
      </div>
    </CustomMainModal>
  </li>
</template>
<script>
import CustomMainModal from '../../Modals/CustomMainModal';
import ErrorList from '@/components/common/errorsList';
import { mapActions, mapGetters } from 'vuex';
import { stagesMixin } from '../../../mixins/stagesMixin';

export default {
  mixins: [stagesMixin],
  components: {
    CustomMainModal,
  },
  props: {
    activity: {
      type: Object,
    },
  },
  data: () => ({
    showModal: false,
    activityComment: '',
  }),
  methods: {
    ...mapActions('managerStoreModule', ['updateActivity']),
    handleClickActivity() {
      /*       this.showModal = true;
      this.activityComment = this.activity.comments; */
    },
    onCloseActivityModal() {
      this.showModal = false;
    },
    onUpdateActivity() {
      this.updateActivity({
        activity_id: this.activity.id,
        activity_comment: this.activityComment,
      }).then(() => {
        this.showModal = false;
        this.$emit('removed-activity');
      });
    },
    getCityName() {
      if (this.activity['job-address']) {
        if (this.activity['job-address'].hasOwnProperty('city_name')) {
          return this.activity['job-address'].city_name;
        }
      }

      return 'N/A';
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerCandidateById', 'getManagerUserProfile']),
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.list-group-item {
  padding: 12px 8px !important;
}
.activity-container {
  display: flex;
  width: 100%;
  img {
    width: 42px;
    height: 42px;
    border-radius: 100%;
    margin: 5px 12px 0 0;
  }
  .activity-content {
    flex: 1;
    .activity-header {
      display: flex;
      margin-bottom: 5px;
      .title {
        display: block;
        flex: 1;
        margin-right: 8px;
        font-size: 14px;
      }
      .date {
        margin-left: auto;
        font-size: 12px;
      }
    }
    .activity-text {
      font-size: 14px;
      p {
        margin-bottom: 0;
        .bold {
          font-weight: 700;
          span {
            color: #f05a00;
          }
        }
      }
    }
  }
}

.modal-activity {
  font-size: 14px;
  li {
    margin-bottom: 12px;
    border: none !important;
    background: none !important;
    padding-right: 0 !important;
    span.title {
      font-weight: 700;
      min-width: 120px;
      display: inline-block;
    }
    .stat {
      background: #465c74;
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      margin-left: 15px;
    }
  }
}
</style>
